import styled, { css } from 'styled-components';

export const BrandLogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const TopBrandLogoContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: ${props => (props.variant === 'header' ? '4px' : '8px')};
`;

export const BrandLogoPlaceholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: 1px dashed ${props => props.theme.colors.additionalText};
  color: ${props => props.theme.colors.additionalText};
  border-radius: 12px;
  font-size: ${props => (props.variant === 'header' ? '11px' : '14px')};
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: 0.02em;
  background: ${props => props.theme.colors.headerBackground};
  width: ${props => (props.variant === 'header' ? '140px' : '220px')};
  min-height: ${props => (props.variant === 'header' ? '22px' : '40px')};
  padding: ${props => (props.variant === 'header' ? '4px 8px' : '8px 12px')};

  ${props => props.isMobile && props.variant !== 'header' && css`
    width: 180px;
    min-height: 32px;
    font-size: 12px;
  `}
`;

export const BrandLogoImage = styled.img`
  display: block;
  width: ${props => (props.variant === 'header' ? '140px' : '330px')};
  height: auto;

  ${props => props.isMobile && props.variant !== 'header' && css`
    width: 220px;
  `}
`;

export const EngageLogoContainer = styled.div`
  display: flex;
  justify-content: center;

  & img {
    display: block;
    height: ${props => (props.variant === 'header' ? (props.isMobile ? '22px' : '35px') : 'auto')};
    max-width: ${props => (props.variant === 'header' ? '140px' : '220px')};
    width: ${props => (props.variant === 'header' ? '100%' : 'auto')};
  }

  ${props => props.isMobile && props.variant !== 'header' && css`
    & img {
      height: 52px;
      width: auto;
      max-width: 100%;
    }
  `}
`;
